import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";
import CookieConsent from "./components/CookieConsent";
import Analytics from "./components/Analytics";

// Single-page main content (no lazy loading needed)
import HomePage from "./pages/HomePage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import CookiePage from "./pages/CookiePage";

// Admin page still uses routing
const AdminPage = lazy(() => import("./pages/AdminPage"));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen bg-[var(--vortex-bg)] flex items-center justify-center">
    <div className="text-[var(--vortex-text-primary)] text-xl">Laden...</div>
  </div>
);

function App() {
  React.useEffect(() => {
    // Force light theme for elderly-friendly design
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.add('light');
    
    // Handle initial hash navigation on page load
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          const headerHeight = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, []);

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
              <Routes>
              {/* Single-page main route */}
                <Route path="/" element={<HomePage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/cookies" element={<CookiePage />} />
              {/* Admin routes still use React Router */}
              <Route path="/admin/*" element={
                <Suspense fallback={<PageLoader />}>
                  <AdminPage />
                </Suspense>
              } />
              </Routes>
            <CookieConsent />
            <Analytics />
            <Toaster />
          </BrowserRouter>
        </AuthProvider>
      </div>
    </ThemeProvider>
  );
}

export default App;
